export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};

export const ENVIRONMENTS = {
  PRODUCTION: 'Production',
  DEMO: 'Demo',
  TEST: 'Test',
  LOCAL: 'Local',
};

// Snowflake editing tool table names
export const COMMODITY_CUSTOM_ATTRIBUTION_TABLE = 'Commodity Custom Attribution';
export const CUSTOM_ATTRIBUTION_TABLE = 'Item Attribution';
export const ASIN_GTIN_MAPPING_TABLE = 'ASIN - GTIN';
export const CASE_UPC_CONSUMER_UPC_MAPPING_TABLE = 'Case UPC - Consumer UPC';
export const KEYWORD_ATTRIBUTION_TABLE = 'Keyword Attribution';
export const CAMPAIGN_ATTRIBUTION_TABLE_ID = 32;
export const API_PUBLISH_RETAILER_IDS = [1, 6];
export const CONTENT_AUTOINGESTION_RETAILER_IDS = [1, 6, 2, 7];
export const WALMART_RETAILER_ID = 1;
export const AMAZON_RETAILER_ID = 6;
export const TARGET_RETAILER_ID = 7;
export const SAMSCLUB_RETAILER_ID = 2;
export const ALL_RETAILERS_NAME = 'All Retailers';
export const AMAZON_ACCOUNT_TYPES = ['seller', 'vendor'];
export const WALMART_API_RETAILER_SERVICE_TYPE = 26;
export const AMAZON_SELLING_PARTNER_API_RETAILER_SERVICE_TYPE = 3;
export const CONTENT_RETAILER_IDS = [1, 2, 5, 6, 7, 8, 10, 12, 13, 14, 15];
export const FALLBACK_IMAGE = '/static/images/applicationIcons/imageNotFound.jpeg';

export const EXCEL_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// Regex
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_REGEX = /^[+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,9}$/;

// UI Animation and Timing Constants
export const ALERT_BADGE_PULSE_INTERVAL = 30; // seconds
export const ALERTS_REFRESH_INTERVAL = 30000; // milliseconds
